// 首页
let first=[
    './static/img/one_bg.png',
    './static/img/one_lou2.png',
    "./static/img/yun1.png",
    './static/img/yun2.png',
    './static/img/yun3.png',
    './static/img/yun4.png',
    './static/img/tian1.png',
    './static/img/second_lou3.png',
    './static/img/shui.png',
    './static/img/3_title.png',
    './static/img/3_bg3.jpg',
    './static/img/4_bg5.png',
    './static/img/3_xiao.png',
    './static/img/3_car.gif',
    './static/img/wave.png',
    './static/img/NO.1.png',
    './static/img/jiangpai2.png',
    './static/img/stars.png',
    './static/img/lihua.png',
    './static/img/4_title.png',
    './static/img/4_title2.png',
    './static/img/4_title3.png',
    './static/img/chitao2.gif',
    './static/img/diaoyu2.png',
    './static/img/liukoushuix2.gif',
    './static/img/liukoushuix2.png',
    './static/img/baozi2.gif',
    './static/img/qiezi2.gif',
    './static/img/niu.gif',
    './static/img/liukoushui_png.png',
    './static/img/qiezi_png.png',
    './static/img/xxjz.png',


    './static/img/1-xiaozun.gif',
    './static/img/zhaopai3.gif',
    './static/img/5_bg3.jpg',
    './static/img/snow.png',
    './static/img/snow2.png',
    './static/img/shoppingcart2.png',
    './static/img/qiao.png',
    './static/img/2-xiaozun.gif',
    './static/img/htjz.png',
    './static/img/noicex.png',
    './static/img/noicex2.png',
    './static/img/5-title.png',
    './static/img/5-title2.png',
    './static/img/hua1.png',
    './static/img/hua2.png',
    './static/img/hua3.png',
    './static/img/hua4.png',
    './static/img/hua5.png',
    './static/imggongzhonghao.jpg',
    './static/img/wa.png',


    './static/img/xianggangbg.png',
    './static/img/xiangganglogo.png',
    './static/img/1-xiaozun2.gif',
    './static/img/1text3.png',
    './static/img/2_title.png',
    './static/img/wutaijaizu2.gif',
    './static/img/h1.gif',
    './static/img/h2.gif',
    './static/img/h3.gif',
    './static/img/h4.gif',
    './static/img/h5.gif',

    './static/img/g1.gif',
    './static/img/g2.gif',
    './static/img/g3.gif',
    './static/img/g4.gif',
    './static/img/g5.gif',
    './static/img/g6.gif',
    './static/img/niu2.gif',
    './static/img/flag.gif',

    './static/img/call3.gif',
    './static/img/callren.png',
    './static/img/niuy.jpg',

];



// activityCont


let listFile = [...first]
console.log(listFile.length,'listFile.length');
// console.log(listFile,'list');
// listFile = [...preloadFile]
export {
    listFile
}
